import React, { useCallback } from 'react';
import {
	Button, Modal, Space, Title,
} from '@components';

import { AgendaItem } from '@api';

interface DeleteAgendaItemModalProps {
	onSubmit: (itemToDelete: AgendaItem) => void,
	item: AgendaItem,
	closeModal: () => void,
}

function DeleteAgendaItemModal(props: DeleteAgendaItemModalProps): JSX.Element {
	const {
		item,
		closeModal,
		onSubmit,
	} = props;

	const handleSubmit = useCallback((): void => {
		onSubmit(item);
		closeModal();
	}, [onSubmit, item, closeModal]);

	return (
		<Modal isOpen>
			<Space alignment="vertical">
				<Title centered>
					Удалить выбранный вопрос повестки?
				</Title>
				<Space alignment="vertical" gap="20px">
					{/* LATER: text component */}
					<div>
						После удаления восстановить вопрос повестки невозможно
					</div>
					<Space centered>
						<Button theme="primary" onClick={handleSubmit}>
							Удалить
						</Button>
						<Button onClick={closeModal}>
							Отменить
						</Button>
					</Space>
				</Space>
			</Space>
		</Modal>
	);
}

export {DeleteAgendaItemModal};